import { render, staticRenderFns } from "./PdpPopupV1.vue?vue&type=template&id=6fd2b7ba&scoped=true&"
import script from "./PdpPopupV1.vue?vue&type=script&lang=js&"
export * from "./PdpPopupV1.vue?vue&type=script&lang=js&"
import style0 from "./PdpPopupV1.vue?vue&type=style&index=0&id=6fd2b7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2b7ba",
  null
  
)

export default component.exports